import { Input, Table, TableColumnsType } from "antd";
import { IAppVersion } from "models/appVersion";
import moment from "moment";
import { otpVerifiedBadge } from "components/Table";
import useOtp from "hooks/useOtp";
import { SearchOutlined } from "@ant-design/icons";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";

export default function Otp() {
  const {
    data: { data, loading, page, per_page, search, total },
    handlePageChange,
    handleSearch,
  } = useOtp();

  return (
    <div className="w-full">
      <div className="w-full px-6 flex flex-wrap-reverse justify-end">
        <Input
          className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
          prefix={<SearchOutlined className="mr-2" />}
          placeholder="Search..."
          onChange={handleSearch}
          value={search}
        />
      </div>
      <div className="w-full mt-8 px-4">
        <Table
          loading={loading}
          columns={columns}
          dataSource={data}
          onChange={handlePageChange}
          pagination={{
            total,
            pageSize: per_page,
            current: page,
            nextIcon: (
              <span className="flex items-center justify-center w-8 h-8 text-2xl">
                <NextIcon />
              </span>
            ),
            prevIcon: (
              <span className="flex items-center justify-center w-8 h-8 text-2xl">
                <PreviousIcon />
              </span>
            ),
          }}
        />
      </div>
    </div>
  );
}

const columns: TableColumnsType<IAppVersion> = [
  {
    title: "Phone",
    dataIndex: "phone",
  },
  {
    title: "Code",
    dataIndex: "code",
  },
  {
    title: "Type",
    dataIndex: "type",
    render: (type: string) => <p>{type.toUpperCase()}</p>,
  },
  {
    title: "Is Verified",
    dataIndex: "is_verified",
    render: otpVerifiedBadge,
  },
  {
    title: "Expire At",
    dataIndex: "expire_at",
    render: (expireAt) => <p> {moment(expireAt).fromNow()} </p>,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    render: (createdAt) => <p>{moment(createdAt).fromNow()}</p>,
  },
];
